mutation UpdateCompetitor(
  $boardId: ID!
  $competitorId: ID!
  $name: String
  $score: Int
  $nameTextColor: String
  $scoreTextColor: String
  $imageUrl: String
  $scoreImageUrl: String
) {
  competitor: StreamToolsUpdateCompetitor(
    boardId: $boardId
    competitorId: $competitorId
    name: $name
    score: $score
    nameTextColor: $nameTextColor
    scoreTextColor: $scoreTextColor
    imageUrl: $imageUrl
    scoreImageUrl: $scoreImageUrl
  ) {
    competitorId
    boardId
    name
    score
    nameTextColor
    scoreTextColor
    imageUrl
    scoreImageUrl
  }
}
